<!-- JAVASCRIPT START -->
<script>
	import Tailwindcss from './Tailwindcss.svelte';
	import Header from './components/Header.svelte';
	import StepBaseSystem from './components/StepBaseSystem.svelte';
	import StepPickerOptions from './components/StepPickerOptions.svelte';
	import StepAdditionalOptions from './components/StepAdditionalOptions.svelte';
	import StepPurchaseOptions from './components/StepPurchaseOptions.svelte';
	import Error from './components/Error.svelte';
	
	//detect environment
	const loc = window.location.href;
	let env = '';
	let testingEnv = false;
	if(loc.indexOf('.test') != -1 || loc.indexOf('localhost') != -1){
		env = 'dev';
		testingEnv = true;
	}
	else if(loc.indexOf('staging') != -1){
		env = 'staging';
		testingEnv = true;
	}
	else {
		env = 'production';
	}

	let showPricing = false;
	const GATrackingID = 'UA-8727745-1';
	const GAUrlPath = '/automated-sample-management/q20configurator/';
	let activeView = testingEnv ? 0 : 0;
	let views = [
		{
			"name" : "Base System",
			"id" : "baseSystem",
			"cart" : []
		},
		{
			"name" : "Picker Options",
			"id" : "pickerOptions",
			"cart" : []
		},
		{
			"name" : "Additional Options",
			"id" : "additionalOptions",
			"cart" : []
		},
		{
			"name" : "Purchase Options",
			"id" : "purchaseOptions",
			"cart" : []
		}
	];
	let priceTally = {
		"unformatted" : 0,
		"usd" : getPriceTally()
	};

	// track pageview with Google
	// https://developers.google.com/analytics/devguides/collection/gtagjs/pages

	//track page view
	gtag('config', GATrackingID, {
		'title' : views[activeView].name,
		'page_location' : concatURL(GAUrlPath, views[activeView].id),
		'page' : GAUrlPath + views[activeView].id
	});

	const handleNextStep = (e) => {
		//add item(s) to cart
		views[activeView].cart = e.detail;

		priceTally.unformatted = getPriceTally();
		priceTally.usd = formatPrice(priceTally.unformatted);

		//console.log(priceTally);
		console.log(views[activeView].cart);

		//change component view
		if(activeView === 0 && views[activeView].cart[0].name === 'Plate Store') {
			activeView = 2;
		}
		else {
			activeView++;
		}

		//track pageview with Google
		gtag('config', GATrackingID, {
			'title' : views[activeView].name,
			'page_location' : concatURL(GAUrlPath, views[activeView].id),
			'page' : GAUrlPath + views[activeView].id
		});

		//scroll to top of page
		window.scrollTo(0, 0);
	}
	
	const handleStepBack = (e) => {
		const viewIndex = e.detail.stepName;
		views.forEach(function(view, ind){
			if (ind >= viewIndex) {
				view.cart = [];
			}
		});

		priceTally.unformatted = getPriceTally();
		priceTally.usd = formatPrice(priceTally.unformatted);

		activeView = viewIndex;
	}

	function getPriceTally(){
		let tally = 0;

		views.forEach(function(view){
			
			view.cart.forEach(function(lineItem){	
				tally += lineItem.price;
			});

		});
		
		window.scrollTo(0, 0);
		return tally;
	}

	function formatPrice(num){
		let formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0
		});

		return formatter.format(num);
	}

	function concatURL(path, lastSegment) {
		return path + lastSegment;
	}

	//region detection
	let regionCall = getRegion();
	let countryCode;

	async function getRegion() {
		const res = await fetch(`https://web.hamiltonsupport.com/tools/q20configurator-tools/location-request.php`);
		const response = await res.text();

		if (res.ok) {
			countryCode = "Not US";

			// Hidden for dev purposes
			// const json = JSON.parse(response);
			// console.log(json);
			// if(json.reserved === true){
			// 	countryCode = "US";
			// }
			// else {
			// 	countryCode = json.country_code;
			// }

			if(countryCode === "US" || countryCode === "CA"){
				showPricing = true;
			}
		} else {
			throw new Error(text);
		}
	}

</script>
<!-- JAVASCRIPT END -->



<!-- HTML START -->
<div class="flex flex-col lg:h-screen">

	{#await regionCall then data}
		<div>
			<Header activeView="{views[activeView].name}" baseSystem={views[0].cart[0] ? views[0].cart[0].name : null} on:handleStepBack={handleStepBack} />
		</div>
		
		{#if activeView === 0}
			<StepBaseSystem showPricing={showPricing} on:nextStep={handleNextStep} />
		{:else if activeView === 1}
			<StepPickerOptions showPricing={showPricing} on:handleStepBack={handleStepBack} on:nextStep={handleNextStep} {priceTally} previousStep="{views[0].name}" />	
		{:else if activeView === 2}
			<StepAdditionalOptions showPricing={showPricing} on:handleStepBack={handleStepBack} on:nextStep={handleNextStep} {priceTally} baseSystem={views[0].cart[0].name} previousStep="{views[views[0].cart[0].name === 'Tube Store' ? 1 : 2].name}" />	
		{:else if activeView === 3}
			<StepPurchaseOptions showPricing={showPricing} on:handleStepBack={handleStepBack} {views} {priceTally} {GATrackingID} {GAUrlPath} previousStep="{views[2].name}" />	
		{/if}
	{:catch error}
		<Error message={error.message} />
	{/await}

</div>
<!-- HTML END -->